import React from 'react'
import Image from './image'

import ernieAndRachell from '../../../static/images/avatars/ernie-and-rachell.jpg'
import gregLaurie from '../../../static/images/avatars/greg-laurie.jpg'
import jonMicah from '../../../static/images/avatars/jon-micah.jpg'
import kevinAndMerry from '../../../static/images/avatars/kevin-and-merry.jpg'
import kieranAndRuth from '../../../static/images/avatars/kieran-and-ruth.jpg'
import leonAndSue from '../../../static/images/avatars/leon-and-sue.jpg'
import macPowell from '../../../static/images/avatars/mac-powell.jpg'
import rigoAndLauren from '../../../static/images/avatars/rigo-and-lauren.jpg'
import thomasAndVeronica from '../../../static/images/avatars/thomas-and-veronica.jpg'

const images = {
  ernieAndRachell: ernieAndRachell,
  gregLaurie: gregLaurie,
  jonMicah: jonMicah,
  kevinAndMerry: kevinAndMerry,
  kieranAndRuth: kieranAndRuth,
  leonAndSue: leonAndSue,
  macPowell: macPowell,
  rigoAndLauren: rigoAndLauren,
  thomasAndVeronica: thomasAndVeronica,
}
export default class ReviewCard extends React.Component {
  render() {
    const { image, quote, cite } = this.props

    return (
      <div className={`review-card${image ? ' with-image' : ''}`}>
        {image && <Image src={images[image]} alt="" />}
        <blockquote>{quote}</blockquote>
        <cite>{cite}</cite>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/review-card.js